import { ROLES } from '@/constants/roles';
import formatRoutes from '@/helpers/user-redesign/formatRoutes';

const routes = [
  {
    path: '/event-exhibition',
    name: 'event-exhibition-base',
    component: () => import('./views/exhibition-base.vue'),
    meta: {
      preventLayoutTemplate: true,
    },
    children: [
      {
        path: ':id',
        name: 'event-exhibition',
        component: () => import('./views/exhibition-main.vue'),
        meta: {
          title: 'Выставка',
        },
      },
      {
        path: 'hall/:id',
        name: 'exhibition-hall',
        component: () => import('./views/exhibition-hall.vue'),
        meta: {
          title: 'Зал выставки',
        },
      },
      {
        path: 'exposition/:id',
        name: 'exhibition-exposition',
        component: () => import('./views/exhibition-exposition.vue'),
        meta: {
          title: 'Экспозиция',
        },
      },
      {
        path: ':id/request',
        // name: 'exhibition-request',
        component: () => import('./views/exhibition-request.vue'),
        meta: {
          title: 'Заявка на выставку',
        },
        children: [
          {
            path: '/',
            name: 'exhibition-request-new',
            component: () => import('./views/exhibition-requests/request-new.vue'),
            meta: {
              layout: 'redesign',
              preventLayoutTemplate: true,
            },
          },
          {
            path: ':requestId',
            name: 'exhibition-request-exists',
            component: () => import('./views/exhibition-requests/request-exists.vue'),
            meta: {
              layout: 'redesign',
              preventLayoutTemplate: true,
            },
          },
        ],
      },
    ],
  },
];

export const exhibitions = {
  path: '/exhibitions-dashboard',
  // name: 'exhibitions-dashboard',
  component: () => import('./views/exhibitions-dashboard/exhibitions-dashboard.vue'),
  meta: {
    title: 'Выставки мероприятий',
    layout: 'ui-design',
    icon: 'mdi-calendar-account-outline',
    accessList: [ROLES.organization],
  },
  children: [
    {
      path: '/',
      name: 'exhibitions-dashboard-list',
      component: () => import('./views/exhibitions-dashboard/exhibitions-dashboard-list.vue'),
      meta: {
        title: 'Выставки мероприятий',
        layout: 'ui-design',
      },
    },
    {
      path: 'exhibition/:id?',
      name: 'exhibitions-dashboard-exhibition',
      component: () => import('./views/exhibitions-dashboard/exhibitions-dashboard-exhibition.vue'),
      meta: {
        back: true,
        title: 'Выставка',
        layout: 'ui-design',
      },
    },
  ],
};

export default [
  ...formatRoutes(routes, { breadcrumbs: false, backControl: false }),
  exhibitions,
];
